/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import 'react-app-polyfill/ie11'

import SiteSearch from 'components/site_search'
import configureStore from 'store'

const store = configureStore()

if (document.getElementById('js-search') != null){
  render(
    <Provider store={store}>
      <SiteSearch />
    </Provider>,
    document.getElementById('js-search')
  )
}
